import { ReactElement } from 'react'
import dayjs from 'utils/dayjs'
import { Eyebrow } from '~elements'
import styles from './DaysOfWeekHeader.module.scss'

import { DATE_FORMAT, DAYS_OF_THE_WEEK } from '~constants'

const DaysOfWeekHeader = () => {
  const daysOfTheWeek: Array<ReactElement> = DAYS_OF_THE_WEEK.map((dayOfTheWeek: number, index: number) => {
    const formattedDay = dayjs().weekday(dayOfTheWeek).format(DATE_FORMAT.DAY_OF_WEEK_FULL_NAME)

    return (
      <Eyebrow
        key={`${dayOfTheWeek}_${index}`}
        title={formattedDay}
        color='gray'
        size='lg'
        justify='center'
        noMarginBottom
      />
    )
  })

  return <div className={styles['calendar__day-name-labels']}>{daysOfTheWeek}</div>
}

export default DaysOfWeekHeader
